import React from 'react';
import { localize } from 'linksoft';

const Resx = localize('App', 'Common');

const ImportSummary = ({ importId, fileName, importeDateTime, total, imported, errors, backUrl }) =>
  (<div className="ImportSummary">
    <table>
      <tbody>
        <tr><td>{Resx.App.ImportId}</td><td>{importId}</td></tr>
        <tr><td>{Resx.Common.File}</td><td>{fileName}</td></tr>
        <tr><td>{Resx.Common.DateAndTime}</td><td>{importeDateTime}</td></tr>
        <tr><td>{Resx.App.TotalMeasurements}</td><td>{total}</td></tr>
        <tr><td>{Resx.App.SuccessfullyImported}</td><td>{imported}</td></tr>
        <tr><td>{Resx.App.Errors}</td><td>{errors}</td></tr>
      </tbody>
    </table>
    <div className="panel-footer validation-buttons">
      <a href={backUrl} className="btn btn-warning btn-sm btn-if">{Resx.Common.Close}</a>
    </div>
  </div>);


export default ImportSummary;


// WEBPACK FOOTER //
// ./App/components/modules/measurement-validator/import-summary/import-summary.js